import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@els/els-react--banner';
import { Button } from '@els/els-react--button';

function SummaryDisclosureBanner({ isFirstSummary, isReactionSummary, onLearnHowItWorks }) {
  const sourceDescription = isReactionSummary ? 'Reaction details' : 'titles, abstracts, and result metadata';

  return (
    <Banner type="info" isVisible isFilled isIconVisible={false} className="ai-search-summary__disclosure">
      <div className="ai-search-summary__disclosure-content" data-testid="summary-disclosure">
        <p>
          {isFirstSummary ? (
            <>
              Up to the <strong className="ai-search-summary__disclosure-emphasis">20 highest-ranked results</strong> were synthesized
            </>
          ) : (
            <>The results were synthesized</>
          )}{' '}
          into a concise summary tailored to your question using only the retrieved {sourceDescription}, not the model&apos;s internal
          knowledge. AI summary quality may vary.
        </p>
        <Button type="link" data-e2e="summary-learn-how-it-works" onClick={onLearnHowItWorks}>
          Learn how it works
        </Button>
      </div>
    </Banner>
  );
}

SummaryDisclosureBanner.propTypes = {
  isFirstSummary: PropTypes.bool.isRequired,
  isReactionSummary: PropTypes.bool.isRequired,
  onLearnHowItWorks: PropTypes.func.isRequired,
};

export default SummaryDisclosureBanner;
